import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Service to coordinate HTTP request cancellation across the application.
 * Provided in root so both interceptors and AuthService can access it.
 */
@Injectable({
   providedIn: 'root'
})
export class HttpCancelService {
   cancelAll: Subject<void> = new Subject();

   /**
    * Emits cancellation signal to all pending HTTP requests.
    * Called on logout to abort in-flight requests.
    */
   cancelPendingRequests(): void {
      this.cancelAll.next();
   }
}
